var _circle, _g, _path, _path2, _g2, _path3, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14,
    r: 9.5,
    fill: "url(#paint0_linear_3387_6133)",
    stroke: "url(#paint1_linear_3387_6133)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3387_6133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.0002,
    cy: 14,
    r: 6.92308,
    fill: "#EFC034"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5359 9.8825C12.7192 9.48513 13.284 9.48513 13.4673 9.8825L14.3282 11.749C14.4029 11.911 14.5564 12.0225 14.7335 12.0435L16.7748 12.2855C17.2093 12.3371 17.3838 12.8742 17.0626 13.1713L15.5534 14.5669C15.4225 14.688 15.3639 14.8684 15.3986 15.0433L15.7992 17.0595C15.8845 17.4887 15.4276 17.8206 15.0457 17.6069L13.2521 16.6029C13.0965 16.5158 12.9068 16.5158 12.7511 16.6029L10.9575 17.6069C10.5756 17.8206 10.1187 17.4887 10.204 17.0595L10.6046 15.0433C10.6394 14.8684 10.5807 14.688 10.4498 14.5669L8.94065 13.1713C8.61937 12.8742 8.79389 12.3371 9.22846 12.2855L11.2697 12.0435C11.4468 12.0225 11.6003 11.911 11.675 11.749L12.5359 9.8825Z",
    fill: "url(#paint2_linear_3387_6133)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3792 20.4469C21.3528 20.4325 21.3311 20.4108 21.3167 20.3844L20.4055 18.7183L19.4943 20.3844C19.4798 20.4108 19.4582 20.4324 19.4318 20.4469L17.7656 21.3581L19.4317 22.2693C19.4581 22.2838 19.4798 22.3054 19.4942 22.3318L20.4054 23.9979L21.3167 22.3318C21.3311 22.3054 21.3528 22.2838 21.3792 22.2693L23.0453 21.3581L21.3792 20.4469Z",
    fill: "#FFF8D6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3387_6133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 4.15916C16.2897 4.15365 16.2815 4.14539 16.276 4.13532L15.9285 3.5L15.581 4.13531C15.5755 4.14537 15.5673 4.15364 15.5572 4.15914L14.9219 4.50661L15.5572 4.85408C15.5673 4.85959 15.5755 4.86785 15.581 4.87791L15.9285 5.51322L16.2759 4.87791C16.2815 4.86785 16.2897 4.85959 16.2998 4.85408L16.9351 4.50661L16.2998 4.15916Z",
    fill: "#FFB800"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 4.15916C16.2897 4.15365 16.2815 4.14539 16.276 4.13532L15.9285 3.5L15.581 4.13531C15.5755 4.14537 15.5673 4.15364 15.5572 4.15914L14.9219 4.50661L15.5572 4.85408C15.5673 4.85959 15.5755 4.86785 15.581 4.87791L15.9285 5.51322L16.2759 4.87791C16.2815 4.86785 16.2897 4.85959 16.2998 4.85408L16.9351 4.50661L16.2998 4.15916Z",
    fill: "#FFF8D6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3387_6133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37792 10.8398C4.36786 10.8343 4.35959 10.826 4.35409 10.816L4.00662 10.1807L3.65916 10.816C3.65365 10.826 3.64539 10.8343 3.63532 10.8398L3 11.1873L3.63531 11.5347C3.64538 11.5402 3.65364 11.5485 3.65915 11.5586L4.0066 12.1939L4.35407 11.5586C4.35958 11.5485 4.36784 11.5402 4.37791 11.5347L5.01322 11.1873L4.37792 10.8398Z",
    fill: "#FF7A00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37792 10.8398C4.36786 10.8343 4.35959 10.826 4.35409 10.816L4.00662 10.1807L3.65916 10.816C3.65365 10.826 3.64539 10.8343 3.63532 10.8398L3 11.1873L3.63531 11.5347C3.64538 11.5402 3.65364 11.5485 3.65915 11.5586L4.0066 12.1939L4.35407 11.5586C4.35958 11.5485 4.36784 11.5402 4.37791 11.5347L5.01322 11.1873L4.37792 10.8398Z",
    fill: "#FFF8D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3387_6133",
    x: 6.07715,
    y: 7.0769,
    width: 13.8462,
    height: 13.8462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.67451 0 0 0 0 0.0901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3387_6133"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.67451 0 0 0 0 0.0901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3387_6133",
    result: "effect2_innerShadow_3387_6133"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3387_6133",
    x: 11.9219,
    y: 0.5,
    width: 8.01318,
    height: 8.01318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3387_6133"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3387_6133",
    x: 0,
    y: 7.18066,
    width: 8.01318,
    height: 8.01318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_3387_6133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3387_6133",
    x1: 7.65228,
    y1: 5.36691,
    x2: 13,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE195"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3387_6133",
    x1: 13,
    y1: 4,
    x2: 13,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3387_6133",
    x1: 8.77539,
    y1: 13.629,
    x2: 17.2278,
    y2: 13.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankOne);
export default __webpack_public_path__ + "static/media/RankOne.7d8e6a01c74743d0fe4f80a8f9b27572.svg";
export { ForwardRef as ReactComponent };